import { IDeliveryZone } from '@app/common';
import { crudEndpointsFactory } from '../crud-endpoints.factory';

export const deliveryZoneApi = crudEndpointsFactory<IDeliveryZone>()('delivery-zones', 'DeliveryZones');

